import {Select} from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
import {useTranslation} from 'react-i18next';
import {EmpresaBeneficiarioEmpresa} from '../../constants';

const {Aceite} = EmpresaBeneficiarioEmpresa;

export default function SelectEmpresaBeneficiarioEmpresaAceite(props) {
  const {t} = useTranslation();

  const createOption = ({id, label}) => (
      <Select.Option value={id}>
        {t(label)}
      </Select.Option>);

  return (
      <Select {...props} >
        {createOption(Aceite.Pendente)}
        {createOption(Aceite.Sim)}
      </Select>
  );
}

SelectEmpresaBeneficiarioEmpresaAceite.propTypes = {
  value: PropTypes.oneOf([
    Aceite.Pendente.id,
    Aceite.Sim.id]),
  onChange: PropTypes.func,
};
